var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1333 13.996H4.86668C4.58668 13.996 4.27334 13.776 4.18001 13.5093L1.42001 5.78935C1.02668 4.68268 1.48668 4.34268 2.43334 5.02268L5.03334 6.88268C5.46668 7.18268 5.96001 7.02935 6.14668 6.54268L7.32001 3.41602C7.69334 2.41602 8.31334 2.41602 8.68668 3.41602L9.86001 6.54268C10.0467 7.02935 10.54 7.18268 10.9667 6.88268L13.4067 5.14268C14.4467 4.39602 14.9467 4.77602 14.52 5.98268L11.8267 13.5227C11.7267 13.776 11.4133 13.996 11.1333 13.996Z",
    stroke: "#FFAC39",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33331 10.6758H9.66665",
    stroke: "#FFAC39",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownIcon);
export default __webpack_public_path__ + "static/media/crown-icon.9e4c8241b5a8d76f7bf2eebe1574bd98.svg";
export { ForwardRef as ReactComponent };